module.exports = [
	{
		"value": "EARL",
		"label": "EARL - Entreprise agricole à responsabilité limitée"
	},
	{
		"value": "EI",
		"label": "EI - Entreprise individuelle"
	},
	{
		"value": "EIRL",
		"label": "EIRL - Entreprise individuelle à responsabilité limitée"
	},
	{
		"value": "EURL",
		"label": "EURL - Entreprise unipersonnelle à responsabilité limitée"
	},
	{
		"value": "GAEC",
		"label": "GAEC - Groupement agricole d'exploitation en commun"
	},
	{
		"value": "GIE",
		"label": "GIE - Groupement d'intérêt économique"
	},
	{
		"value": "GEIE",
		"label": "GEIE - Groupement européen d'intérêt économique"
	},
	{
		"value": "SA",
		"label": "SA - Société anonyme"
	},
	{
		"value": "SC",
		"label": "SC - Société civile"
	},
	{
		"value": "SCM",
		"label": "SCM - Société civile de moyens"
	},
	{
		"value": "SCI",
		"label": "SCI - Société civile immobilière"
	},
	{
		"value": "SCP",
		"label": "SCP - Société civile professionnelle"
	},
	{
		"value": "SCIC",
		"label": "SCIC - Société coopérative d'intérêt collectif"
	},
	{
		"value": "SCOP",
		"label": "SCOP - Société coopérative ouvrière de production"
	},
	{
		"value": "SEL",
		"label": "SEL - Société d'exercice libéral"
	},
	{
		"value": "SELCA",
		"label": "SELCA - Société d'exercice libéral en commandite par actions"
	},
	{
		"value": "SELAS",
		"label": "SELAS - Société d'exercice libéral par actions simplifiée"
	},
	{
		"value": "SELAFA",
		"label": "SELAFA - Société d'exercice libéral à forme anonyme"
	},
	{
		"value": "SELARL",
		"label": "SELARL - Société d'exercice libéral à responsabilité limitée"
	},
	{
		"value": "SICA",
		"label": "SICA - Société d'intérêt collectif agricole"
	},
	{
		"value": "SEM",
		"label": "SEM - Société d'économie mixte"
	},
	{
		"value": "SEML",
		"label": "SEML - Société d'économie mixte locale"
	},
	{
		"value": "SCA",
		"label": "SCA - Société en commandite par actions"
	},
	{
		"value": "SCS",
		"label": "SCS - Société en commandite simple"
	},
	{
		"value": "SNC",
		"label": "SNC - Société en nom collectif"
	},
	{
		"value": "SEP",
		"label": "SEP - Société en participation"
	},
	{
		"value": "SAS",
		"label": "SAS - Société par actions simplifiée"
	},
	{
		"value": "SASU",
		"label": "SASU - Société par actions simplifiée unipersonnelle"
	},
	{
		"value": "SARL",
		"label": "SARL - Société à responsabilité limitée"
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./shared/legalForm.json
 ** module id = 947
 ** module chunks = 1
 **/